import {
  FETCH_PACKAGES_REQUEST,
  FETCH_PACKAGES_SUCCESS,
  FETCH_PACKAGES_FAILURE,
  FETCH_PACKAGE_REQUEST,
  FETCH_PACKAGE_SUCCESS,
  FETCH_PACKAGE_FAILURE,
  SELECT_PACKAGE_REQUEST,
  SELECT_PACKAGE_SUCCESS,
  SELECT_PACKAGE_FAILURE,
  FOCUS_PACKAGE,
  FOCUS_DETAILS,
  DISMISS_ERROR,
  SHOW_PAYPAL_SUBSCRIPTION_ERROR,
  DISMISS_PAYPAL_SUBSCRIPTION_ERROR,
  RESET,
} from '../actions/packages'
import { FETCH_CART_ITEMS_SUCCESS } from '../actions/cart'
import { PAY_NOW_SUCCESS } from '../actions/checkout'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  packages: [],
  packagesById: {},
  isReady: false,
  hasError: false,
  errorMessage: '',
  previousPackageId: -1,
  focusedPackageId: -1,
  selectedPackageId: -1,
  focusDetails: false,
  paypalSubscriptionError: false,
}

const packagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PACKAGES_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_PACKAGES_SUCCESS:
      let packages = []
      let packagesById = {}
      action.payload.packages.forEach(pkg => {
        packagesById[pkg.id] = pkg
        packages.push(pkg.id)
      })
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        packages: packages,
        packagesById: packagesById,
        focusedPackageId: action.payload.focusedPackageId,
        previousPackageId: action.payload.focusedPackageId,
      }
    case FETCH_PACKAGES_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load available packages',
      }
    case FETCH_PACKAGE_REQUEST:
      return {
        ...state,
        packagesById: {
          ...state.packagesById,
          [action.payload.id]: {
            ...state.packagesById[action.payload.id],
            detailsRequested: true,
          },
        },
      }
    case FETCH_PACKAGE_SUCCESS:
      return {
        ...state,
        packagesById: {
          ...state.packagesById,
          [action.payload.id]: {
            ...state.packagesById[action.payload.id],
            items: action.payload.items,
          },
        },
      }
    case FETCH_PACKAGE_FAILURE:
      return {
        ...state,
        packagesById: {
          ...state.packagesById,
          [action.payload.id]: {
            ...state.packagesById[action.payload.id],
            items: [],
          },
        },
      }
    case SELECT_PACKAGE_REQUEST:
      return state
    case SELECT_PACKAGE_SUCCESS:
      const selectedPackageId = parseInt(action.payload.pkg.id, 10)
      const newPackagesById = {}
      for (let pkgId in state.packagesById) {
        newPackagesById[pkgId] = {
          ...state.packagesById[pkgId],
          isSelected: false,
        }
      }
      return {
        ...state,
        selectedPackageId: selectedPackageId,
        previousPackageId: selectedPackageId,
        focusedPackageId: -1,
        focusDetails: false,
        packagesById: newPackagesById,
      }
    case SELECT_PACKAGE_FAILURE:
      return {
        ...state,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to select the package',
      }
    case FOCUS_PACKAGE:
      return {
        ...state,
        focusedPackageId: action.payload.id,
        previousPackageId:
          state.focusedPackageId !== -1
            ? state.focusedPackageId
            : state.previousPackageId,
        focusDetails: false,
      }
    case FOCUS_DETAILS:
      return {
        ...state,
        focusDetails: true,
        focusedPackageId: -1,
        previousPackageId:
          state.focusedPackageId !== -1
            ? state.focusedPackageId
            : state.previousPackageId,
      }
    case DISMISS_ERROR:
      return {
        ...state,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_CART_ITEMS_SUCCESS:
      const newSelectedPackage = action.payload.items.find(
        item => item.itemType === 'channel_group'
      )
      return {
        ...state,
        selectedPackageId:
          newSelectedPackage !== undefined ? newSelectedPackage.itemId : -1,
      }
    case SHOW_PAYPAL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        paypalSubscriptionError: true,
      }
    case DISMISS_PAYPAL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        paypalSubscriptionError: false,
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case RESET:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default packagesReducer
